import { IAddress } from './address/address.interface';

export class AddressesCache {
    static get KEY() {
        return 'addresses';
    }

    public static get<T>(key: string, getType = 'addresses'): T | null {
        const stored = sessionStorage.getItem(key);
        if (stored) {
            if (getType === 'addresses') {
                const json = JSON.parse(stored);
                const { addresses, lastUpdated } = json;
                if (new Date().getTime() - lastUpdated < 3600000) {
                    return addresses;
                }
            }

            if (getType === 'searchAddress') {
                const json = JSON.parse(stored);
                return json;
            }
        }

        return null;
    }

    public static store<T>(key: string, addresses: T) {
        sessionStorage.setItem(key, JSON.stringify(addresses));
    }
}
